import MainLayout from 'src/layouts/MainLayout';
import { lazy } from 'react';
import { RouteI } from 'src/models/router';
import { RoutePath } from 'src/enums/routePath';

const LoginPage = lazy(() => import('../pages/Login'));
const CompanyPage = lazy(() => import('../pages/Company'));
const CompanyCreatePage = lazy(
  () => import('../pages/Company/components/CompanyCreate')
);
const CompanyDetailPage = lazy(
  () => import('../pages/Company/components/CompanyDetail')
);
const CompanyRegistration = lazy(() => import('../pages/CompanyRegistration'));
const ProductPage = lazy(() => import('../pages/Product'));
const ProductCreatePage = lazy(() => import('../pages/Product/Create'));
const ProductDetailPage = lazy(() => import('../pages/Product/Detail'));
const ProductEdit = lazy(() => import('../pages/Product/Edit'));
const HistoryScanPage = lazy(() => import('../pages/HistoryScan'));
const HistoryScanDetailPage = lazy(
  () => import('../pages/HistoryScan/components/ScanDetail')
);
const ReportPage = lazy(() => import('../pages/Report'));
const ReportDetailPage = lazy(
  () => import('../pages/Report/components/ReportDetail')
);
const ChangePasswordPage = lazy(() => import('../pages/ChangePassword'));
const CompanyRegistrationManagementPage = lazy(
  () => import('../pages/CompanyRegistrationManagement')
);
const CompanyRegistrationDetailPage = lazy(
  () =>
    import('../pages/CompanyRegistrationManagement/CompanyRegistrationDetail')
);
const CompanyRegistrationEditPage = lazy(
  () => import('../pages/CompanyRegistrationManagement/CompanyRegistrationEdit')
);
const CompanyAdminPage = lazy(() => import('../pages/CompanyAdmin'));
const CompanyAdminDetailPage = lazy(
  () => import('../pages/CompanyAdmin/components/CompanyDetail')
);
const CompanyAdminCreatePage = lazy(
  () => import('../pages/CompanyAdmin/components/CompanyCreate')
);
const CompanyStaffPage = lazy(() => import('../pages/CompanyStaff'));
const CompanyStaffDetailPage = lazy(
  () => import('../pages/CompanyStaff/components/CompanyDetail')
);
const CompanyStaffCreatePage = lazy(
  () => import('../pages/CompanyStaff/components/CompanyCreate')
);
const StickerPage = lazy(() => import('../pages/Sticker'));
const StickerDetailPage = lazy(
  () => import('../pages/Sticker/components/SickerDetail')
);
const RenewalPage = lazy(() => import('../pages/Renewal'));
const RenewalDetailPage = lazy(
  () => import('../pages/Renewal/components/RenewaDetail')
);
const CertificationRegistrationPreview = lazy(
  () =>
    import(
      '../pages/Company/components/CompanyDetail/components/CertificationRegistrationPreview'
    )
);
const CertificationLicencePreview = lazy(
  () =>
    import(
      '../pages/Company/components/CompanyDetail/components/CertificationLicencePreview'
    )
);
const CompanyStatisticsPage = lazy(() => import('../pages/Analytic'));
const ForgotPasswordPage = lazy(() => import('../pages/ForgotPassword'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const NotPermissionPage = lazy(() => import('../pages/NotPermissionPage'));
const SystemAdminPage = lazy(() => import('../pages/SystemAdmin'));
const SystemAdminDetailPage = lazy(
  () => import('../pages/SystemAdmin/components/SystemAdminDetail')
);
const SystemAdminCreatePage = lazy(
  () => import('../pages/SystemAdmin/components/SystemAdminCreate')
);
const SettingPage = lazy(() => import('../pages/Setting'));

export const routes: RouteI[] = [
  {
    path: RoutePath.LOGIN,
    Component: LoginPage
  },
  {
    path: RoutePath.NOT_FOUND,
    Component: NotFoundPage
  },
  {
    path: RoutePath.NOT_PERMISSION,
    Component: NotPermissionPage
  },
  {
    path: RoutePath.CHANGE_PASSWORD,
    Component: ChangePasswordPage,
    Layout: <MainLayout />
  },
  {
    path: `${RoutePath.FORGOT_PASSWORD}`,
    Component: ForgotPasswordPage
  },
  {
    path: `${RoutePath.FORGOT_PASSWORD}/:token`,
    Component: ForgotPasswordPage
  },
  {
    path: RoutePath.COMPANY_REGISTRATION,
    Component: CompanyRegistration
  },
  {
    path: `${RoutePath.COMPANY_REGISTRATION}${RoutePath.DETAIL}/:token`,
    Component: CompanyRegistration
  },
  {
    path: RoutePath.COMPANY,
    Component: CompanyPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.COMPANY}${RoutePath.CREATE}`,
    Component: CompanyCreatePage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.COMPANY}${RoutePath.DETAIL}/:id`,
    Component: CompanyDetailPage,
    Layout: <MainLayout />
    // isPrivate: true
  },
  {
    path: `${RoutePath.COMPANY}${RoutePath.EDIT}/:id`,
    Component: CompanyCreatePage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: RoutePath.PRODUCT,
    Component: ProductPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.PRODUCT}${RoutePath.CREATE}`,
    Component: ProductCreatePage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.PRODUCT}${RoutePath.DETAIL}/:id`,
    Component: ProductDetailPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.PRODUCT}${RoutePath.EDIT}/:id`,
    Component: ProductEdit,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: RoutePath.HISTORY_SCAN,
    Component: HistoryScanPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.HISTORY_SCAN}${RoutePath.DETAIL}/:id`,
    Component: HistoryScanDetailPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: RoutePath.REPORT,
    Component: ReportPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.REPORT}${RoutePath.DETAIL}/:id`,
    Component: ReportDetailPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: RoutePath.COMPANY_REGISTRATION_MANAGEMENT,
    Component: CompanyRegistrationManagementPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.COMPANY_REGISTRATION_MANAGEMENT}${RoutePath.DETAIL}/:id`,
    Component: CompanyRegistrationDetailPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.COMPANY_REGISTRATION_MANAGEMENT}${RoutePath.EDIT}/:id`,
    Component: CompanyRegistrationEditPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: RoutePath.COMPANY_ADMIN,
    Component: CompanyAdminPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.COMPANY_ADMIN}${RoutePath.DETAIL}/:id`,
    Component: CompanyAdminDetailPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.COMPANY_ADMIN}${RoutePath.CREATE}`,
    Component: CompanyAdminCreatePage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.COMPANY_ADMIN}${RoutePath.EDIT}/:id`,
    Component: CompanyAdminCreatePage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: RoutePath.COMPANY_STAFF,
    Component: CompanyStaffPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.COMPANY_STAFF}${RoutePath.DETAIL}/:id`,
    Component: CompanyStaffDetailPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.COMPANY_STAFF}${RoutePath.CREATE}`,
    Component: CompanyStaffCreatePage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.COMPANY_STAFF}${RoutePath.EDIT}/:id`,
    Component: CompanyStaffCreatePage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: RoutePath.STICKER,
    Component: StickerPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.STICKER}${RoutePath.DETAIL}/:id`,
    Component: StickerDetailPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: RoutePath.RENEWAL,
    Component: RenewalPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.RENEWAL}${RoutePath.DETAIL}/:id`,
    Component: RenewalDetailPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.COMPANY}${RoutePath.DETAIL}/:id${RoutePath.REGISTRATION_PREVIEW}/:chainTypeId`,
    Component: CertificationRegistrationPreview,
    isPrivate: true
  },
  {
    path: `${RoutePath.COMPANY}${RoutePath.DETAIL}/:id${RoutePath.LICENCE_PREVIEW}/:chainTypeId`,
    Component: CertificationLicencePreview,
    isPrivate: true
  },
  {
    path: RoutePath.ANALYTIC,
    Component: CompanyStatisticsPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: RoutePath.SYSTEM_ADMIN,
    Component: SystemAdminPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.SYSTEM_ADMIN}${RoutePath.DETAIL}/:id`,
    Component: SystemAdminDetailPage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.SYSTEM_ADMIN}${RoutePath.CREATE}`,
    Component: SystemAdminCreatePage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: `${RoutePath.SYSTEM_ADMIN}${RoutePath.EDIT}/:id`,
    Component: SystemAdminCreatePage,
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: RoutePath.SETTING,
    Component: SettingPage,
    Layout: <MainLayout />,
    isPrivate: true
  }
];
